module.exports = __webpack_public_path__ + "img/footer-contact-icon-row-dark-chevy.adf229fb.png";